import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  attractions: {},
  config: {},
  FAQ: {},
  ferries: [],
  home: [],
  parks: {},
  theParks: [],
  howItWorksData: {},
  terms: {},
  bannerData: [],
};

const appStateSlice = createSlice({
  name: "appState",
  initialState,
  reducers: {
    addConfig(state, action) {
      state.config = action.payload;
    },
    addTheParks(state, action) {
      state.theParks = action.payload;
    },
    addPark: (state, action) => {
      const { pid, data } = action.payload;
      state.parks[pid] = addImgUrlsToPark(data, pid);
    },
    addAttractions(state, action) {
      state.attractions = action.payload.attractions;
    },
    addFerriesData(state, action) {
      state.ferries = action.payload.ferries;
    },
    addHomeData(state, action) {
      state.home = action.payload[0];
    },
    addFaqData(state, action) {
      state.FAQ = action.payload;
    },
    addHowItWorksData(state, action) {
      state.howItWorksData = action.payload;
    },
    addTermsData(state, action) {
      state.terms = action.payload.terms;
    },
    addBannerData(state, action) {
      state.bannerData = action.payload;
    },
  },
});

export const {
  addConfig,
  addTheParks,
  addPark,
  addAttractions,
  addFerriesData,
  addHomeData,
  addFaqData,
  addHowItWorksData,
  addTermsData,
  addBannerData,
} = appStateSlice.actions;

export const appStateReducer = appStateSlice.reducer;

export const attractionsSelector = (state) => state.appState.attractions;
export const getAttractionSelector = (attractionID) => (state) => state.appState.attractions[attractionID] || {};
export const theParksSelector = (state) => state.appState.theParks;
export const getParkSelector = (pid) => (state) => state.appState.parks[pid];
export const homeDataSelector = (state) => state.appState.home;
export const ferriesDataSelector = (state) => state.appState.ferries;
export const faqDataSelector = (state) => state.appState.FAQ.faqs;
export const hasFaqSelector = (state) => state.appState.FAQ;
export const getConfigSelector = (state) => state.appState.config;
export const getTermsDataSelector = (state) => state.appState.terms;
export const bannerDataSelector = (state) => state.appState.bannerData;
export const getHowItWorksDataSelector = (state) => state.appState.howItWorksData;
export const getCancellationProtectionDataSelector = (state) => state.appState.howItWorksData?.cancellationProtection;
export const getAccommodationDataSelector = (state) => state.appState.howItWorksData?.accommodation;
export const getExtrasDataSelector = (state) => state.appState.howItWorksData?.extras;
export const getHowItWorksCardsDataSelector = (state) => state.appState.howItWorksData?.howItWorksCards;

const addImgUrlsToPark = (data, pid) => {
  const imgsValues = data.PARKIMGS;

  const folder = pid.substring(0, 1);

  const imgUrls = imgsValues?.map(
    (img) =>
      `//content.breakfreeholidays.co.uk/images/parks/${folder}/${pid}/gallery/${pid}-${String(img).padStart(
        2,
        "0",
      )}.jpg`,
  );
  return { ...data, imgUrls };
};
